/** API route map: URLS.Controller.CandidateBadges */
export const CandidateBadges = {
      Name: 'CandidateBadges/',
      GetCandidateBadges: 'get-candidate-badges-list',
      AddCandidateBadges: 'add-candidate-badge',
      UpdateCandidateBadges: 'update-candidate-badge',
      DeleteCandidateBadges: 'delete-candidate-badge',
      SearchBadges: 'search-badges',
      AssignBadges: 'assign-badges',
      GetAllAndAssignedBadges: 'get-all-and-assigned',
      GetAssignedBadges: 'get-assigned-badges',
};
